import isInletLoading from './is_inlet_loading';

export default (inletValue?: any): boolean => {
    return !isInletLoading(inletValue);
};
